import * as React from 'react'
import styled from 'styled-components'
import { colors } from '@src/styles/theme'
import { ConfigUiHint, JsonSchema } from '../../../types'

type Props = {
  label: string
  value: boolean
  schema?: JsonSchema
  hint?: ConfigUiHint
  disabled?: boolean
  onChange: (val: boolean) => void
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  gap: 12px;
  min-height: 44px;
`

const LabelWrap = styled.div`
  flex: 1;
`

const Label = styled.span`
  display: block;
  color: ${(p) => p.theme.label};
  font-size: 14px;
  font-family: 'NunitoSansSemiBold';
`

const HelpText = styled.span`
  display: block;
  color: ${(p) => p.theme.listDesc};
  font-size: 12px;
  margin-top: 2px;
`

const Toggle = styled.button<{ $active: boolean }>`
  width: 44px;
  height: 24px;
  border-radius: 12px;
  border: none;
  cursor: pointer;
  position: relative;
  flex-shrink: 0;
  transition: background 0.15s;
  background: ${(p) => p.$active ? p.theme.accent : p.theme.button.cancel.default};

  &::after {
    content: '';
    position: absolute;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: ${colors.white};
    top: 3px;
    left: ${(p) => p.$active ? '23px' : '3px'};
    transition: left 0.15s;
  }

  &:focus-visible { box-shadow: 0 0 0 2px ${(p) => p.theme.accent}; outline: none; }
  &:disabled { opacity: 0.5; cursor: not-allowed; }
`

export function BooleanField({ label, value, hint, disabled, onChange }: Props) {
  return (
    <Wrapper>
      <LabelWrap>
        <Label>{label}</Label>
        {hint?.help && <HelpText>{hint.help}</HelpText>}
      </LabelWrap>
      <Toggle
        type="button"
        $active={!!value}
        disabled={disabled}
        onClick={() => onChange(!value)}
        aria-label={label}
      />
    </Wrapper>
  )
}
